export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_of.js
// module id = 783
// module chunks = 2 3 4 5 6 7 8 10